'use client'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { useUnity } from '@/hooks/use-unity'

export default function Registration() {
  const { unity } = useUnity()

  return (
    <Accordion className="w-full" collapsible type="single">
      <AccordionItem className="border-[#F3E8FC] border-b" value="item-1">
        <AccordionTrigger className="text-start font-medium text-[#64686D] text-lg hover:no-underline">
          Existe taxa de matrícula?
        </AccordionTrigger>
        <AccordionContent className="ml-4 font-normal text-[#ABACAD] text-sm">
          Não, a matrícula é totalmente gratuita. Mas fique ligado que é por
          tempo limitado.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem className="border-[#F3E8FC] border-b" value="item-2">
        <AccordionTrigger className="text-start font-medium text-[#64686D] text-lg hover:no-underline">
          Por que fazer uma pós-graduação digital na {unity.full_name}?
        </AccordionTrigger>
        <AccordionContent className="ml-4 font-normal text-[#ABACAD] text-sm">
          Fazer uma pós-graduação digital na {unity.full_name} oferece
          flexibilidade de horários, uma variedade de cursos, corpo docente
          qualificado, acessibilidade, custo-benefício, interatividade e
          suporte, certificação reconhecida, e oportunidades de networking.
          Esses benefícios tornam a {unity.full_name} uma opção vantajosa para
          quem busca conciliar estudos com outras responsabilidades e investir
          na carreira profissional.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem className="border-[#F3E8FC] border-b" value="item-3">
        <AccordionTrigger className="text-start font-medium text-[#64686D] text-lg hover:no-underline">
          Quem pode fazer uma pós-graduação?
        </AccordionTrigger>
        <AccordionContent className="ml-4 font-normal text-[#ABACAD] text-sm">
          Para realizar a inscrição é necessário que o aluno apresente o diploma
          de ensino superior.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem className="border-[#F3E8FC] border-b" value="item-4">
        <AccordionTrigger className="text-start font-medium text-[#64686D] text-lg hover:no-underline">
          Em quanto tempo vou receber o acesso ao meu curso?
        </AccordionTrigger>
        <AccordionContent className="ml-4 font-normal text-[#ABACAD] text-sm">
          O acesso ao curso será liberado automaticamente assim que o pagamento
          for confirmado pelo sistema.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem className="border-[#F3E8FC] border-b" value="item-5">
        <AccordionTrigger className="text-start font-medium text-[#64686D] text-lg hover:no-underline">
          Quais os documentos necessários para a matrícula?
        </AccordionTrigger>
        <AccordionContent className="ml-4 font-normal text-[#ABACAD] text-sm">
          <p>
            Para que a sua matrícula seja efetivada, você vai precisar subir em
            nossa plataforma a seguinte documentação:
          </p>
          <ul className="ml-8 list-disc">
            <li>RG ou CNH;</li>
            <li>CPF;</li>
            <li>
              Diploma de graduação - bacharelado, licenciatura ou tecnólogo -
              frente e verso/assinado;
            </li>
            <li>Certidão de nascimento/casamento;</li>
          </ul>
        </AccordionContent>
      </AccordionItem>

      <AccordionItem className="border-[#F3E8FC] border-b" value="item-6">
        <AccordionTrigger className="text-start font-medium text-[#64686D] text-lg hover:no-underline">
          Em quanto tempo recebo o meu certificado digital após ser solicitado?
        </AccordionTrigger>

        <AccordionContent className="ml-4 font-normal text-[#ABACAD] text-sm">
          O certificado digital será enviado para o e-mail cadastrado em até 20
          dias após a data da solicitação.
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
